import * as Component from 'components';
import {
  WORK_ORDER_MAX_ITEMS,
  WORK_ORDER_PLAYLIST_TYPE,
  WORK_ORDER_WINDOW_DAYS,
} from 'content/shorts-preset/constants';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as PlaylistComponent from '../components';
import PlaylistContentList from '../components/PlaylistContentList';
import { playlistApiService } from '../services/playlistApiService';

/**
 * Types whose contents come from playlist rules (recent / tag / series / season) rather
 * than a hand-picked item list.
 *
 * `bebridge` belongs here: `PlaylistMrssService.get_bebridge_mrss` builds the work-order
 * feed from `PlaylistRuleService.apply_rules(...)` and never reads `playlist_items`, so a
 * manually curated list would edit something the feed ignores.
 */
const RULE_BASED_PLAYLIST_TYPES = ['dynamic', WORK_ORDER_PLAYLIST_TYPE];

const PlaylistEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [playlistType, setPlaylistType] = useState<string>('');

  useEffect(() => {
    setIsLoading(true);
    playlistApiService.fetchById(Number(id)).then(data => {
      setPlaylistType(data.type);
      setIsLoading(false);
    });
  }, [id]);

  const isWorkOrder = playlistType === WORK_ORDER_PLAYLIST_TYPE;

  const playlistTabItem = RULE_BASED_PLAYLIST_TYPES.includes(playlistType)
    ? [
        {
          key: 'playlist-rule',
          title: 'Playlist Rule',
          component: <PlaylistComponent.PlaylistRule />,
        },
        {
          key: 'videos',
          title: 'Videos',
          component: (
            <PlaylistComponent.PlaylistVideos
              id={id as string}
              // The rules pick the pool; the work-order feed then narrows it by air date and
              // caps it. Without this note a full list next to an empty feed reads as a bug.
              notice={
                isWorkOrder
                  ? `These are all episodes the rules select. The work order feed additionally ` +
                    `keeps only the ones that aired within the last ${WORK_ORDER_WINDOW_DAYS} ` +
                    `days (${WORK_ORDER_MAX_ITEMS} at most), so it is normally shorter than ` +
                    `this list — and empty when nothing aired recently.`
                  : undefined
              }
            />
          ),
        },
      ]
    : [
        {
          key: 'videos',
          title: 'Videos',
          component: <PlaylistContentList />,
        },
      ];

  const playlistComponents = [
    {
      key: 'detail',
      title: 'Detail',
      component: <PlaylistComponent.PlaylistDetail />,
    },
    ...playlistTabItem,
  ];

  return (
    <Component.BasePageComponent>
      {isLoading ? (
        <Component.LoadingSpinnerComponent />
      ) : (
        <Component.TapComponent components={playlistComponents} />
      )}
    </Component.BasePageComponent>
  );
};

export default PlaylistEdit;
